import React from 'react';

import { useSelector } from 'react-redux';

import { useLDFlags } from '../../utils/LD/useLDFlags';
import { getExcludedProductTypesForAfterpay } from '../../utils/selectors';
import AfterpayMessaging from '../AfterpayMessaging/AfterpayMessaging';
import KlarnaMessaging from '../KlarnaMessaging/KlarnaMessaging';

interface PaymentMessagingLineProps {
  total: number;
  afterpayClassName: string;
}

export function PaymentMessagingLine({
  total,
  afterpayClassName,
}: PaymentMessagingLineProps) {
  const { 'additional-payment-methods': additionalPaymentMethods } =
    useLDFlags();
  const isKlarnaEnabled =
    additionalPaymentMethods === 'klarna' ||
    additionalPaymentMethods === 'both';
  const excludedProductTypesForAfterpay = useSelector(
    getExcludedProductTypesForAfterpay
  );

  return (
    <>
      {isKlarnaEnabled ? (
        <KlarnaMessaging
          baseAmount={!isNaN(total) ? total : 0}
          justKlarna={false}
        />
      ) : (
        <AfterpayMessaging
          afterpayClassName={afterpayClassName}
          afterpayAmount={!isNaN(total) ? total : 0}
          excludedProducts={excludedProductTypesForAfterpay}
        />
      )}
    </>
  );
}
